"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Account = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var AccountIconList = function AccountIconList(_ref) {
  var icons = _ref.icons;
  return icons && icons.length > 0 && _react.default.createElement("span", {
    className: "account-icon-list"
  }, icons.map(function (_ref2, index) {
    var icon = _ref2.icon,
        title = _ref2.title;
    return _react.default.createElement("img", {
      key: index,
      src: icon,
      title: title,
      className: "account-icon"
    });
  }));
};

var Account = function Account(_ref3) {
  var account = _ref3.account,
      _ref3$suffix = _ref3.suffix,
      suffix = _ref3$suffix === void 0 ? "" : _ref3$suffix;
  return _react.default.createElement("span", {
    className: "account"
  }, account.name, suffix, _react.default.createElement(AccountIconList, {
    icons: account.icons
  }));
};

exports.Account = Account;

var AccountList = function AccountList(_ref4) {
  var accounts = _ref4.accounts;

  switch (accounts.length) {
    case 1:
      return _react.default.createElement("span", null, _react.default.createElement("span", {
        className: "account"
      }, accounts[0].name, _react.default.createElement(AccountIconList, {
        icons: accounts[0].icons
      })));

    case 2:
      return _react.default.createElement("span", null, _react.default.createElement("span", {
        className: "account"
      }, accounts[0].name, _react.default.createElement(AccountIconList, {
        icons: accounts[0].icons
      })), ' and ', _react.default.createElement("span", {
        className: "account"
      }, accounts[1].name, _react.default.createElement(AccountIconList, {
        icons: accounts[1].icons
      })));

    case 3:
      return _react.default.createElement("span", null, _react.default.createElement("span", {
        className: "account"
      }, accounts[0].name, _react.default.createElement(AccountIconList, {
        icons: accounts[0].icons
      })), ",", _react.default.createElement("span", {
        className: "account"
      }, accounts[1].name, _react.default.createElement(AccountIconList, {
        icons: accounts[1].icons
      })), ' and ', _react.default.createElement("span", {
        className: "account"
      }, accounts[2].name, _react.default.createElement(AccountIconList, {
        icons: accounts[2].icons
      })));

    default:
      return _react.default.createElement("span", null, _react.default.createElement("span", {
        className: "account"
      }, accounts[0].name, _react.default.createElement(AccountIconList, {
        icons: accounts[0].icons
      })), ",", _react.default.createElement("span", {
        className: "account"
      }, accounts[1].name, _react.default.createElement(AccountIconList, {
        icons: accounts[1].icons
      })), ' and ', accounts.length - 2, " more");
  }
};

AccountList.format = function (_ref5) {
  var accounts = _ref5.accounts;

  switch (accounts.length) {
    case 1:
      return accounts[0].name;

    case 2:
      return "".concat(accounts[0].name, " and ").concat(accounts[1].name);

    case 3:
      return "".concat(accounts[0].name, ", ").concat(accounts[1].name, " and ").concat(accounts[2].name);

    default:
      return "".concat(accounts[0].name, ", ").concat(accounts[1].name, " and ").concat(accounts.length - 2, " more");
  }
};

var _default = AccountList;
exports.default = _default;